export default {
    title: 'Benachrichtigungen',
    emptyTitle: 'Noch keine Benachrichtigungen',
    emptyText: 'Hier werden deine Benachrichtigungen angezeigt.'
}
